/* ============================================================
   ATELIER HAÏYA — Carrousel images
   card-carousel.js

   initCard  — cartes produit (.product-card) sur collection/accueil
   initGallery — galerie principale (sections/main-product.liquid)
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     UTILITAIRES PARTAGÉS
     ---------------------------------------------------------- */

  function makeSVG(points) {
    return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
      + 'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<polyline points="' + points + '"/></svg>';
  }

  function makeBtn(extraClass, label, svgPoints) {
    const btn = document.createElement('button');
    btn.className     = 'card-carousel__btn ' + extraClass;
    btn.type          = 'button';
    btn.setAttribute('aria-label', label);
    btn.innerHTML     = makeSVG(svgPoints);
    return btn;
  }

  /* Arrête la lecture d'un élément média (video ou iframe) */
  function pauseMediaItem(item) {
    if (!item) return;
    const video = item.querySelector('video');
    if (video) video.pause();
    /* iframe YouTube/Vimeo : effacer + remettre le src coupe la lecture */
    const iframe = item.querySelector('iframe');
    if (iframe && iframe.src) {
      const src = iframe.src;
      iframe.src = '';
      iframe.src = src;
    }
  }

  /* ----------------------------------------------------------
     CARTES PRODUIT (collection + homepage)
     ---------------------------------------------------------- */

  function initCard(card) {
    const imgs = card.querySelectorAll('.product-card__img');
    if (imgs.length < 2) return;

    let current = 0;
    const total = imgs.length;

    imgs.forEach((img, i) => {
      img.style.opacity = i === 0 ? '1' : '0';
      img.style.zIndex  = i === 0 ? '2' : '1';
    });

    function show(index) {
      imgs[current].style.opacity = '0';
      imgs[current].style.zIndex  = '1';
      current = (index + total) % total;
      imgs[current].style.opacity = '1';
      imgs[current].style.zIndex  = '2';
    }

    const wrap = card.querySelector('.product-card__image-wrap');
    if (!wrap) return;

    const prevBtn = makeBtn('card-carousel__btn--prev', 'Image précédente', '15 18 9 12 15 6');
    const nextBtn = makeBtn('card-carousel__btn--next', 'Image suivante',   '9 18 15 12 9 6');
    wrap.appendChild(prevBtn);
    wrap.appendChild(nextBtn);

    prevBtn.addEventListener('click', e => { e.preventDefault(); show(current - 1); });
    nextBtn.addEventListener('click', e => { e.preventDefault(); show(current + 1); });

    let startX = 0;
    wrap.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', e => {
      const delta = e.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 40) show(delta < 0 ? current + 1 : current - 1);
    }, { passive: true });

    card.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') show(current + 1);
      else if (e.key === 'ArrowLeft')  show(current - 1);
    });
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll('.product-card').forEach(initCard);
  }

  /* ----------------------------------------------------------
     GALERIE PRODUIT (sections/main-product.liquid)
     ---------------------------------------------------------- */

  function initGallery() {
    const mainWrap  = document.getElementById('gallery-main');
    const thumbWrap = document.getElementById('gallery-thumbs');
    if (!mainWrap) return;

    const items = Array.from(mainWrap.querySelectorAll('.product-gallery__media-item'));
    if (items.length === 0) return;

    let current = 0;

    /* S'assurer que seul le premier item est actif au départ */
    items.forEach((item, i) => {
      item.classList.toggle('is-active', i === 0);
    });

    function thumbAt(index) {
      return thumbWrap
        ? thumbWrap.querySelector('[data-index="' + index + '"]')
        : null;
    }

    function show(index) {
      index = (index + items.length) % items.length;
      if (index === current) return;

      /* Pause du média en cours avant de le masquer */
      pauseMediaItem(items[current]);

      items[current].classList.remove('is-active');
      thumbAt(current)?.classList.remove('product-gallery__thumb--active');

      current = index;

      items[current].classList.add('is-active');
      const nextThumb = thumbAt(current);
      if (nextThumb) {
        nextThumb.classList.add('product-gallery__thumb--active');
        nextThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    /* Flèches — seulement si plusieurs médias */
    if (items.length > 1) {
      const prevBtn = makeBtn('card-carousel__btn--prev', 'Média précédent', '15 18 9 12 15 6');
      const nextBtn = makeBtn('card-carousel__btn--next', 'Média suivant',   '9 18 15 12 9 6');
      mainWrap.appendChild(prevBtn);
      mainWrap.appendChild(nextBtn);

      prevBtn.addEventListener('click', e => { e.preventDefault(); show(current - 1); });
      nextBtn.addEventListener('click', e => { e.preventDefault(); show(current + 1); });

      /* Swipe tactile */
      let startX = 0;
      mainWrap.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', e => {
        const delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 40) show(delta < 0 ? current + 1 : current - 1);
      }, { passive: true });

      /* Clavier */
      mainWrap.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight')     show(current + 1);
        else if (e.key === 'ArrowLeft') show(current - 1);
      });
    }

    /* Synchroniser avec les clics sur les miniatures (toujours actif) */
    if (thumbWrap) {
      thumbWrap.addEventListener('click', e => {
        const btn = e.target.closest('.product-gallery__thumb');
        if (!btn) return;
        const idx = parseInt(btn.dataset.index, 10);
        if (!isNaN(idx)) show(idx);
      });
    }
  }

  /* ----------------------------------------------------------
     INITIALISATION
     ---------------------------------------------------------- */

  document.addEventListener('DOMContentLoaded', () => {
    initAll(document);
    initGallery();
  });

  /* API publique : re-init après filtrage AJAX */
  window.CardCarouselModule = { initAll, initGallery };

})();
